import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { format } from '@/@core/utils/string';
import { Symbols } from '@/symbols';
let CompanyReportApi = class CompanyReportApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.getCompanyAccountReport = (account_id, chart_id, params) => {
            const url = format(this.urls.getCompanyAccountReport, {
                account_id,
                chart_id,
            });
            const queryParams = {
                legends: _.join(params.legends, ','),
                freq: 'monthly',
                ..._.omit(params, 'legends'),
            };
            return this.http.get({
                url,
                params: queryParams,
            });
        };
        this.getAccountsReportTable = (params) => {
            const url = this.urls.getUserStats;
            const queryParams = {
                legends: _.join(params.legends, ','),
                freq: 'monthly',
                ..._.omit(params, 'legends'),
            };
            return this.http.get({
                url,
                params: queryParams,
            });
        };
    }
};
CompanyReportApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CompanyReportApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyReportApi);
export { CompanyReportApi };
